import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

export interface JournalProcessLog {
  journalProcessLogId: string;
  journalPlanningRecordId: string;
  processStep: string;
  returnCode: number;
  rowCount: number;
  processTime: number;
  changeUser: string;
  changeDateTime: string;
}

@Injectable({
  providedIn: 'root',
})
export class JournalprocesslogService {
  private apiUrl = environment.apiUrl + '/kbj-frontend/api/v1';
  private readonly httpOptions = { withCredentials: true };
  private http: HttpClient = inject(HttpClient);

  /**
   * Returns the processing log lines of a journal planning record.
   */
  getByJournalPlanningRecord(journalPlanningRecordId: string): Observable<JournalProcessLog[]> {
    if (!journalPlanningRecordId) {
      return of([]);
    }

    return this.http
      .get<JournalProcessLog[] | null>(
        `${this.apiUrl}/Processing/JournalProcessLog/ByContext/${journalPlanningRecordId}`,
        this.httpOptions,
      )
      .pipe(
        map((jsonData) => jsonData ?? []),
        catchError((err: HttpErrorResponse) => this.handleListError(err)),
      );
  }

  private handleListError(err: HttpErrorResponse): Observable<JournalProcessLog[]> {
    if (err.status === 404 || err.status === 204) {
      return of([]);
    }

    const errorMessage = `An error has occurred: ${err.error?.message ?? err.message}`;
    console.error(errorMessage);
    return throwError(() => errorMessage);
  }
}
